import { ControlTypeEnum } from "../abstraction/index";

// Objet de base � tous les contr�les affich�s � l'�cran
export abstract class ControlBaseModel {
	constructor() {
	}
	Key: string = "";
	Id: number = 0;
	ControlType: ControlTypeEnum = 0;
}
